module.exports = __webpack_public_path__ + "static/img/chunji.58339a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/chunji.png
// module id = zDPP
// module chunks = 1 3